var map = {
	"./template.bet575": 1741,
	"./template.bet575.tsx": 1741,
	"./template.bet777": 1742,
	"./template.bet777.tsx": 1742,
	"./template.betblast": 1743,
	"./template.betblast.tsx": 1743,
	"./template.betprofessor": 1744,
	"./template.betprofessor.tsx": 1744,
	"./template.betroyale": 1745,
	"./template.betroyale.tsx": 1745,
	"./template.betstride": 1746,
	"./template.betstride.tsx": 1746,
	"./template.buffalobet": 1747,
	"./template.buffalobet.tsx": 1747,
	"./template.chromabet": 1748,
	"./template.chromabet.tsx": 1748,
	"./template.default": 715,
	"./template.default.tsx": 715,
	"./template.fiestabet": 1749,
	"./template.fiestabet.tsx": 1749,
	"./template.forsport": 1750,
	"./template.forsport.tsx": 1750,
	"./template.gigabet": 1751,
	"./template.gigabet.tsx": 1751,
	"./template.goldenbet888": 1752,
	"./template.goldenbet888.tsx": 1752,
	"./template.goldenrush": 1753,
	"./template.goldenrush.tsx": 1753,
	"./template.hyperbet": 1754,
	"./template.hyperbet.tsx": 1754,
	"./template.juicybet": 1755,
	"./template.juicybet.tsx": 1755,
	"./template.junglebet": 1756,
	"./template.junglebet.tsx": 1756,
	"./template.magnumbet": 1757,
	"./template.magnumbet.tsx": 1757,
	"./template.oldgill": 1758,
	"./template.oldgill.tsx": 1758,
	"./template.puntcity": 1759,
	"./template.puntcity.tsx": 1759,
	"./template.puntgenie": 1760,
	"./template.puntgenie.tsx": 1760,
	"./template.pyramidbet": 1761,
	"./template.pyramidbet.tsx": 1761,
	"./template.questbet": 1762,
	"./template.questbet.tsx": 1762,
	"./template.slambet": 1763,
	"./template.slambet.tsx": 1763,
	"./template.sterlingparker": 1764,
	"./template.sterlingparker.tsx": 1764,
	"./template.templebet": 1765,
	"./template.templebet.tsx": 1765,
	"./template.titanbet": 1766,
	"./template.titanbet.tsx": 1766,
	"./template.ts": 991,
	"./template.vikingbet": 1767,
	"./template.vikingbet.tsx": 1767,
	"./template.volcanobet": 1768,
	"./template.volcanobet.tsx": 1768,
	"./template.wellbet": 1769,
	"./template.wellbet.tsx": 1769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2472;